import styled from "styled-components";
import { Card as KosmosCard } from "kosmos-ui/lib";

export const TestimonialsContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: ${({ theme }) => theme.colorsPalette.black.default};
  padding: 72px;

  @media (max-width: 600px) {
    padding: 40px;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const CardsSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:not(:last-child) {
    margin-right: 16px;
  }

  @media (max-width: 600px) {
    &:not(:last-child) {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }
`;

export const CardBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 16px;

  @media (max-width: 600px) {
    margin-left: 0;
  }
`;

export const Card = styled(KosmosCard)`
  width: 304px;
  flex-direction: row;
  box-shadow: rgba(115, 131, 169, 0.1) 0px 0px 48px 14px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  @media (max-width: 600px) {
    width: fit-content;
  }
`;

export const CardHeader = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colorsPalette.white.default};
  font-size: 16px;
  font-weight: 400;

  @media (max-width: 600px) {
    text-align: center;
  }
`;

export const CardSubheader = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colorsPalette.blue.default};
  font-size: 12px;
  font-weight: 400;
  margin-top: 6px;

  @media (max-width: 600px) {
    text-align: center;
    margin-bottom: 16px;
  }
`;

export const CardParagraph = styled.p`
  color: ${({ theme }) => theme.colorsPalette.gray.light};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  margin-top: 8px;
`;

export const LogosContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const CustomerAvatar = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  font-size: 24px;

  @media (max-width: 600px) {
    margin-bottom: 16px;
  }
`;
